import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { IMaintenanceConfig } from "./maintenanceConfig.types"
import { MaintenanceConfig, MaintenanceBanner } from "./maintenanceConfig"

export interface IMaintenanceConfigRaw {
  isMaintenanceBannerEnabled: boolean
  maintenanceBannerContent: {
    title: string
    message: string
    pages: string[]
  }
}

export const MaintenanceConfigParser: IParser<
  IMaintenanceConfig,
  IMaintenanceConfigRaw
> = {
  toDomain(data: IMaintenanceConfigRaw): IMaintenanceConfig {
    try {
      return new MaintenanceConfig(
        data.isMaintenanceBannerEnabled,
        new MaintenanceBanner(
          data.maintenanceBannerContent.title,
          data.maintenanceBannerContent.message,
          data.maintenanceBannerContent.pages,
        ),
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
